import React from 'react';
import withSettings from '../utils/withSettings';
import { Checkbox, createTheme, ThemeProvider } from '@material-ui/core';
import Optional from '../utils/optional';

const CustomCheckbox = ({
  value,
  settings,
  disabled = false,
  size = 'medium',
  onChange = () => {}
}) => {
  const theme = createTheme({
    overrides: {
      MuiSvgIcon: { root: { fontSize: '25px' } },
      MuiCheckbox: {
        root: {
          fontSize: '20px',
          '&$disabled': {
            pointerEvents: 'auto'
          }
        },
        colorSecondary: {
          color: settings.colors.modal_header,
          '&$checked': { color: settings.colors.modal_header }
        }
      },
      MuiTooltip: {
        tooltip: {
          fontSize: '12px',
          width: '200px'
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Checkbox
        checked={Optional(value).or(false)}
        disabled={disabled}
        size={size}
        onChange={onChange}
      />
    </ThemeProvider>
  );
};

export default withSettings(CustomCheckbox);
